import {
    HISTORY_ACTIONS_LOADED,
    HISTORY_ITEM_LOADED,
    HISTORY_ITEM_LOADING,
    HISTORY_LOADED,
    HISTORY_LOADING
} from "../../actions/actionTypes";

const initialState = {
    historyItems: [],
    historyItem: null,
    loading: false,
    historyActions: [],
};

export default function(state = initialState, action) {
    switch(action.type) {
        case HISTORY_LOADING:
            return {
                ...state,
                loading: true
            };
        case HISTORY_LOADED:
            return {
                ...state,
                loading: false,
                historyItems: action.payload,
            };
        case HISTORY_ITEM_LOADING:
            return {
                ...state,
                loading: true,
                historyItem: null,
            };
        case HISTORY_ITEM_LOADED:
            return {
                ...state,
                loading: false,
                historyItem: action.payload,
            };
        case HISTORY_ACTIONS_LOADED:
            return {
                ...state,
                historyActions: action.payload,
            };
        default:
            return state;
    }
}